"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const sizeMapping = {
  extraLarge: 48,
  extraSmall: 12,
  large: 32,
  medium: 24,
  small: 16
};
const withAdjustedProps = WrappedComponent => {
  const SvgShield = ({
    size,
    ...restOfProps
  }) => {
    const sizeValue = sizeMapping[size];
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
      height: sizeValue,
      width: sizeValue,
      viewBox: "0 0 24 24"
    }, restOfProps));
  };
  SvgShield.propTypes = {
    fill: _propTypes.default.string,
    size: _propTypes.default.oneOf(Object.keys(sizeMapping))
  };
  SvgShield.defaultProps = {
    fill: "#000",
    size: "small"
  };
  return SvgShield;
};
function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23 5.1c0-.5-.3-.9-.7-1l-9.7-4h-1.2l-9.7 4c-.4.1-.7.5-.7 1 0 1.9 0 6.4 2 11 3 7 8.9 7.9 8.9 7.9s6-1 8.9-7.8c2-4.7 2.2-9.3 2.1-11zm-5.7 5l-6 6a.4.4 0 01-.5 0L9.7 15l-2.5-2.5a.4.4 0 010-.5l.9-.9a.4.4 0 01.5 0l2.5 2.5 4.8-4.9a.4.4 0 01.6 0l.8.9a.4.4 0 010 .5z"
  }));
}
var _default = exports.default = withAdjustedProps(SvgShield);